module.exports = __webpack_public_path__ + "static/media/bookmark-icon.fd59f395.svg";